<mat-dialog-content>
  {{ info | translate }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>
    {{ "components.info-dialog.button" | translate }}
  </button>
</mat-dialog-actions>
